<template>
    <v-layout align-start>
        <v-flex>
            <v-app>
                <div>
                    <div>
                        <!-- Listar -->
                        <h2>Users</h2>
                        <!-- Campo de búsqueda por nombre -->
                        <v-text-field v-model="search" append-icon="search" label="Search by first or last name or corporate email" outlined dense></v-text-field>
                        <v-divider class="mx-4" inset vertical></v-divider>                              
                        <!-- Diálogo para crear un nuevo registro -->
                        <v-dialog v-model="dialog" max-width="50%">
                            <template v-slot:activator="{ on }">
                                <v-row>
                                    <v-col cols="12" md="12" lg="2">
                                        <v-btn color="primary" dark class="mb-2" v-on="on" @click="nueva">New User</v-btn>
                                    </v-col>
                                    <v-col cols="12" md="12" lg="2">
                                        <v-select v-model="filtroActual" :items="opcionesFiltro" label="Filter for State" outlined dense></v-select>
                                    </v-col>
                                    <v-col cols="12" md="12" lg="2">
                                        <v-select v-model="filtroActual2" :items="agenciesObs" item-text="n_agency" item-value="oid" label="Filter for Agency" outlined dense></v-select>
                                    </v-col>
                                </v-row> 
                            </template>                            
                            <v-card>
                                <v-card-title>
                                    <span class="text-h5">{{ formTitle }}</span>
                                </v-card-title>
                                <v-card-text>
                                    <v-container grid-list-md>
                                        <v-layout wrap>
                                            <v-flex xs12 sm12 md4>
                                                <v-text-field v-model="dato.name" label="Name" :rules="[validar1]" auto-grow></v-text-field>
                                            </v-flex>                                            
                                            <v-flex xs12 sm12 md4>
                                                <v-text-field v-model="dato.surname" label="Surname" :rules="[validar1]" auto-grow></v-text-field>
                                            </v-flex>   
                                            <v-flex xs12 sm12 md6>
                                                <v-text-field v-model="dato.correo_corporativo" label="Corporate Email" :rules="[validarCorreo]" auto-grow></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm12 md5>
                                                <v-select v-model="dato.oid_agency" :items="agencies" item-text="n_agency" item-value="oid" label="Agency">
                                                    <template v-slot:label> Agency
                                                        <span class="red-asterisk">*</span>
                                                    </template>
                                                </v-select>
                                            </v-flex>
                                            <v-flex xs12 sm12 md4>
                                                <v-select v-model="dato.oid_rol" :items="rols" item-text="n_role" item-value="oid" label="Role"></v-select>
                                            </v-flex>
                                            <v-flex xs12 sm12 md6>
                                                <v-text-field v-if="isNew" v-model="dato.pswd" label="Password" type="password" :rules="[validarpswd]"></v-text-field> 
                                            </v-flex>                                        
                                        </v-layout>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1" text @click="cerrar">Cancelar</v-btn>
                                    <v-btn color="blue darken-1" text @click="guardar">{{ isNew ? 'New' : 'Update' }}</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </div>
                    <v-data-table :headers="headers" :items="filtered" item-key="oid">
                        <template v-slot:items="props">
                            <td>{{ props.item.name }}</td>
                            <td>{{ props.item.surname }}</td>                        
                            <td>{{ props.item.usuario }}</td>
                            <td>{{ props.item.correo_corporativo }}</td>
                            <td>{{ obtenerNombreA(props.item.oid_agency) }}</td>
                            <td>{{ obtenerNombreR(props.item.oid_rol) }}</td>
                            <td>{{ props.item.pswd_act }}</td>
                        <td class="text-center">
                            <v-btn small color="primary" @click="mostrar(props.item.oid)">Mostrar</v-btn>
                            <v-btn small color="warning" @click="editar(props.item)">Editar</v-btn>
                            <v-btn small color="error" @click="confirmarEliminar(props.item.oid)">Eliminar</v-btn>
                        </td>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon small class="mr-2" v-on="on" @click="mostrar(item.oid)">mdivisibility</v-icon>
                                </template>
                                    <span>Detail</span>
                            </v-tooltip> 
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon small class="mr-2" v-on="on" @click="editar(item)">mdiedit</v-icon>
                                </template>
                                    <span>Edit</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon small v-on="on" @click="confirmarEliminar(item.oid)">mdidelete</v-icon>
                                </template>
                                    <span>Delete</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon v-if="(item.pswd_act === null || item.pswd_act === 0)" small v-on="on" @click="activeUser(item.oid, 1)" class="green--text">mdisettings</v-icon>
                                </template>
                                <span>Active User</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon v-if="(item.pswd_act === 1)" small v-on="on" @click="activeUser(item.oid, 0)" class="red--text">mdisettings</v-icon>
                                </template>
                                <span>Desactive User</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                <!-- Formulario de creación/edición -->      
                <v-form ref="form" @submit.prevent="guardar">
                </v-form>
                <!-- Diálogo para ver detalle-->
                <v-dialog v-model="dialogdetail" max-width="50%">
                    <v-card>
                    <v-card-title class="headline">Details</v-card-title>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12 sm12 md4>
                                    <v-text-field v-model="dato.name" label="Name" readonly disabled class="rounded"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm12 md4>
                                    <v-text-field v-model="dato.surname" label="Surname" readonly disabled class="rounded"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm12 md4>
                                    <v-text-field v-model="dato.correo_corporativo" label="Corporate Email" readonly disabled class="rounded"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm12 md4>
                                    <p><strong>Agency:</strong> {{ nombrea }}</p>
                                </v-flex> 
                                <v-flex xs12 sm12 md4>
                                    <p><strong>Rol:</strong> {{ nombrer }}</p>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="secondary" text @click="cancelarDetalle">Close</v-btn>
                    </v-card-actions>
                    </v-card>
                </v-dialog>

                <!-- Dialogo para Mensaje cargando-->
                <v-dialog v-model="dialog_guardando" max-width="550px"> 
                    <v-card>
                        <v-card-title class="headline">Saving.....</v-card-title>
                    </v-card>
                </v-dialog>

                <!-- Mensaje de confirmación-->
                <v-snackbar v-model="guardarExitoso" color="success" top>
                    Saved successfully
                    <template v-slot:action="{ attrs }">
                        <v-btn color="success" text v-bind="attrs" @click="registroExitoso = false">Close</v-btn>
                    </template>
                </v-snackbar>

                <!-- Diálogo de confirmación para eliminar -->
                <v-dialog v-model="showConfirmDialog" max-width="500px">
                    <v-card>
                    <v-card-title class="headline">Confirm deletion</v-card-title>
                    <v-card-text>
                        Are you sure you want to delete this record?
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="primary" text @click="eliminar(confirmItemId)">Sí</v-btn>
                        <v-btn color="secondary" text @click="cancelarEliminar">No</v-btn>
                    </v-card-actions>
                    </v-card>
                </v-dialog>
                </div>
            </v-app>
        </v-flex>
    </v-layout>
</template>
  
<script>
import axios from 'axios';
  
  export default {
    data() {
      return {
        datos: [],
        agencies: [],
        agenciesObs: [],
        rols: [],
        agenciesFiltrados: [],        
        areas: [],
        dato: {
          oid: 0,
          name:'',
          surname: '',
          correo_corporativo: '',
          oid_agency: null,
          oid_rol: null,
          pswd: '',
          pswd_act: null,
        },
        isNew: true,
        filtroActual: null,
        filtroActual2: null,
        headers: [
            { text: 'Actions', value: 'actions', sortable: false },
            { text: 'Name', value: 'name' }, 
            { text: 'Surname', value: 'surname' },
            { text: 'Corporate Email', value: 'correo_corporativo' },
            { text: 'Agency', value: 'nombre_agency' },
            { text: 'Role', value: 'nombre_rol' },
        ],
        menu2: false,//Menu para fecha Nacimiento
        
        dialog: false, // Controla la visibilidad del diálogo
        formTitle: '', // Título del diálogo
        dialogdetail: false,
        showConfirmDialog: false,
        confirmItemId: null,
        search: '', // Valor del campo de búsqueda
        dialog_guardando: false,
        guardarExitoso: false,
        opcionesFiltro: [
            { text: 'All', value: null },
            { text: 'Active', value: 1 },
            { text: 'Desactive', value: 0 }
            // Puedes agregar más opciones de filtro aquí según tus necesidades
        ],
      };
    },
    computed: {
            filtered() {
                let datos = this.datos.map(dato => {
                    return {
                        ...dato,
                        nombre_agency: this.obtenerNombreA(dato.oid_agency),
                        nombre_rol: this.obtenerNombreR(dato.oid_rol),
                    };
                }).filter(dato =>
                    dato.name.toLowerCase().includes(this.search.toLowerCase()) ||
                    dato.surname.toLowerCase().includes(this.search.toLowerCase()) ||
                    dato.correo_corporativo.toLowerCase().includes(this.search.toLowerCase())
                );

                // Aplica el filtro por estado si se ha seleccionado una opción
                if (this.filtroActual !== null) {
                    datos = datos.filter(dato => dato.pswd_act === this.filtroActual);
                }

                // Aplica el filtro por estado si se ha seleccionado una opción
                if (this.filtroActual2 !== null) {
                    datos = datos.filter(dato => dato.oid_agency === this.filtroActual2);
                }

                return datos;
            },
            nombrer() {
                if (this.dato.oid_rol) {
                    const rol = this.rols.find((rol) => rol.oid === this.dato.oid_rol);
                    return rol ? rol.n_role : '';
                }
                    return '';
            },
            nombrea() {
                if (this.dato.oid_agency) {
                    const agency = this.agencies.find((agency) => agency.oid === this.dato.oid_agency);
                    return agency ? agency.n_agency : '';
                }
                    return '';
            },        
        },
    //MOUNTED se utiliza para interactuar con el DOM y realizar operaciones relacionadas con el mismo
    mounted() {
      this.listar();
    },
    //CREATED se utiliza principalmente para inicializar datos y realizar operaciones lógicas
    created() {
        this.listar();
    },
    methods: {
        // Obtener la lista de áreas
        async listar() {
            try {
                const response = await axios.get('api/Users/Listar');
                const responseagency = await axios.get('api/Agencies/Listar');
                const responserol = await axios.get('api/Roles/Listar');

                this.datos = response.data;
                this.agencies = responseagency.data;
                this.agenciesObs = [...responseagency.data]; // Clonar los datos para mantenerlos independientes
                this.agenciesObs.unshift({ n_agency: 'All', oid: null });
                this.rols = responserol.data;
            } catch (error) {
                console.error(error);
            }
        },
        obtenerNombreA(oid_agency) {
            const agency = this.agencies.find((agency) => agency.oid === oid_agency);
            return agency ? agency.n_agency : '';                
        },
        obtenerNombreR(oid_rol) {
            const rol = this.rols.find((rol) => rol.oid === oid_rol);
            return rol ? rol.n_role : '';                
        },
        cerrar() {
            this.dialog = false;
        },
        validarpswd(value) {
            if (value && value.length < 12) {
                return 'The password must contain a minimum of 11 characters';
            }
            // Utiliza expresiones regulares para verificar si se cumplen los requisitos.
            const hasLowercase = /[a-z]/.test(value);//minuscula
            const hasUppercase = /[A-Z]/.test(value);//mayuscula
            const hasNumber = /\d/.test(value);//numero
            const hasSpecialChar = /[!@#$%^&*]/.test(value);//caracter especial

            if (!hasLowercase) {
                return 'The password must contain at least one lowercase letter.';
            }

            if (!hasUppercase) {
                return 'The password must contain at least one uppercase letter.';
            }

            if (!hasNumber) {
                return 'The password must contain at least one number.';
            }

            if (!hasSpecialChar) {
                return 'The password must contain at least one special character (for example: !@#$%^&*).';
            }

            return true;
        },
        //VALIDAR BP
        validar1(value) {
            if (value && value.length > 500) {
                return 'The field cannot exceed 500 characters';
            }
            return true;
        }, 
        validar2(value) {
            if (value && value.length > 500) {
                return 'The field cannot exceed 500 characters';
            }
            return true;
        }, 
        
        //VALIDAR CORREO
        validarCorreo(value) {
            const num = /^[A-Za-z0-9._%+-]+@(un|undp|cepal|fao|ilo|iom|paho|unaids|unesco|unfpa|unhcr|unicef|unido|unwomen|wfp|unops)\.org$/;

            if (!num.test(value)) {
                return 'The email must be valid (example@(un|undp|cepal|fao|ilo|iom|paho|unaids|unesco|unfpa|unhcr|unicef|unido|unwomen|wfp|unops).org)';
            }

            if (value.length > 500) {
                return 'The field cannot exceed 500 characters';
            }
            // Realiza una solicitud al servidor para verificar si el correo ya existe
            const userdata = this.datos.find((user) => user.correo_corporativo === value);

            if (userdata) {
                return 'The email already exists, please enter another';
            }

            return true;
        },
        
        // Mostrar detalles de un área
        async mostrar(id) {
            try {
                const response = await axios.get(`api/Users/Mostrar/${id}`);
                this.dato = response.data;
                this.isNew = false;
                this.formTitle = 'User Detail';
                this.dialogdetail = true;
            } catch (error) {
                console.error(error);
            }
        },
        
        // Abrir el diálogo para crear una nueva área
        nueva() {
            this.dato = { oid: 0, name:'', surname: '', correo_corporativo: '', oid_agency: null, oid_rol: null, pswd: '' };
            this.isNew = true;
            this.formTitle = 'New User';
            this.dialog = true;
        },
        // Abrir el diálogo para editar un área existente
        editar(dato) {
            this.dato = { ...dato };
            this.isNew = false;
            this.formTitle = 'Update User';
            this.dialog = true;
        },

        // Guardar el área creada o actualizada
        async guardar() {
            this.dialog_guardando = true;
            // Validar los campos del formulario antes de guardar
            if (this.$refs.form.validate()) {
                try {
                    // Realizar la lógica para guardar o actualizar el área
                    if (this.isNew) {
                        // Crear el área
                        await axios.post('api/Users/Crear', this.dato);
                    } else {
                        // Actualizar el área
                        await axios.put('api/Users/Actualizar', this.dato);
                    }
                    // Limpiar el formulario después de guardar o actualizar
                    this.dato = { oid: 0, name:'', surname: '', correo_corporativo: '', oid_agency: null, oid_rol: null, pswd: '' };

                    // Después de guardar exitosamente el registro:
                    this.guardarExitoso = true;
                    this.dialog = false;
                    await this.listar();
                    
                } catch (error) {
                    console.error(error);
                } finally {
                    // Independientemente de si la solicitud tuvo éxito o no, detenemos el estado de carga.
                    this.dialog_guardando = false;
                }
            }
        },
        // Eliminar un área
        async eliminar(id) {
            try {
                await axios.delete(`api/Users/Eliminar/${id}`);
                this.listar();
                this.cancelarEliminar();
            } catch (error) {
                console.error(error);
            }
        },
        async activeUser(id, newact){
            let datosNuevos = {};
            try {
                // Realizar la lógica para guardar o actualizar el área
                datosNuevos = {
                    oid: id,
                    pswd_act: newact
                };
                // Crear el área
                await axios.put('api/Users/ActualizarActive', datosNuevos);
                
                // Limpiar el formulario después de guardar o actualizar
                this.dato = { oid: 0, pswd_act: null};

                // Después de guardar exitosamente el registro:
                this.guardarExitoso = true;
                this.dialog = false;
                await this.listar();
                
            } catch (error) {
                console.error(error);
            } finally {
                // Independientemente de si la solicitud tuvo éxito o no, detenemos el estado de carga.
                this.dialog_guardando = false;
            }
        },
        // Confirmar eliminación de un área
        confirmarEliminar(id) {
            this.confirmItemId = id;
            this.showConfirmDialog = true;
        },
        // Cancelar eliminación
        cancelarEliminar() {
            this.confirmItemId = null;
            this.showConfirmDialog = false;
        },
        // Cancelar Detalle
        cancelarDetalle() {
            this.dialogdetail = false;
            
        },
    },
  };
</script> 
<style>
    h2 {
        margin-top: 24px;
        margin-bottom: 16px;
    }
    .v-textarea--auto-grow .v-input__control {
        min-height: 20px; /* Ajusta la altura mínima del campo según tus preferencias */
    }
</style>